import React, { FC } from 'react';
import cls from './TableHeader.module.css';
import classNames from 'classnames';

export const TableHeader = () => {
    return (
        <div className={classNames(cls.TableHeader)}>
            <div />
            <div>{i18next.t('TableHeader.return.title')}</div>
            <div className={classNames(cls.capacity)}>
                {i18next.t('TableHeader.return.capacity')}
            </div>

            <div className={classNames(cls.dateBlock)}>
                {i18next.t('TableHeader.return.dateBlock')}
            </div>
            <div className={classNames(cls.daysBlock)}>
                {i18next.t('TableHeader.return.daysBlock')}
            </div>
        </div>
    );
};
